export default __webpack_public_path__ + "static/media/scanqr-active.02362295.svg";